import { computed } from "vue";
import { useStore } from "vuex";

export type UserSecurityProtocols = {
  allowOtpSms: boolean;
  allowOtpEmail: boolean;
  allowBackupCodes: boolean;
};

export const useUserSecurityProtocols = (): UserSecurityProtocols => {
  const store = useStore();

  const isPhoneConfirmed = computed(
    () => store.state.userInfo.user.isPhoneConfirmed
  );
  const isEmailConfirmed = computed(
    () => store.state.userInfo.user.isEmailConfirmed
  );
  const hasBackupCodesSetup = computed(
    () => store.state.userInfo.user.hasBackupCodesSetup
  );

  return {
    allowOtpSms: computed(() => isPhoneConfirmed.value).value,
    allowOtpEmail: computed(() => isEmailConfirmed.value).value,
    allowBackupCodes: computed(() => hasBackupCodesSetup.value).value,
  };
};
